(function() {
  'use strict';

  var formSelector = [
    'form[data-cdm-ajax-cart-form]',
    'form.cdm-grid-atc',
    'form.product-form-v3[data-product-form]',
    'form.product-form-v3[data-search-product-form]'
  ].join(',');

  var toastTimer = null;

  function route(name, fallback) {
    if (window.theme && window.theme.routes && window.theme.routes[name]) {
      return window.theme.routes[name];
    }

    return fallback;
  }

  function ensureToast() {
    var toast = document.querySelector('[data-cdm-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'cdm-cart-toast';
    toast.setAttribute('data-cdm-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = [
      '<div class="cdm-cart-toast__message" data-cdm-cart-toast-message></div>',
      '<div class="cdm-cart-toast__actions">',
      '<a class="cdm-cart-toast__button cdm-cart-toast__button--primary" href="' + route('cartPage', '/cart') + '">Ver carrinho</a>',
      '<button class="cdm-cart-toast__button cdm-cart-toast__button--secondary" type="button" data-cdm-cart-toast-close>Continuar comprando</button>',
      '</div>'
    ].join('');

    document.body.appendChild(toast);

    toast.querySelector('[data-cdm-cart-toast-close]').addEventListener('click', function() {
      hideToast();
    });

    return toast;
  }

  function showToast(message, isError) {
    var toast = ensureToast();
    var messageEl = toast.querySelector('[data-cdm-cart-toast-message]');

    if (messageEl) {
      messageEl.textContent = message || 'Produto adicionado ao carrinho.';
    }

    toast.classList.toggle('cdm-cart-toast--error', !!isError);
    toast.classList.add('is-visible');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, isError ? 6000 : 4200);
  }

  function hideToast() {
    var toast = document.querySelector('[data-cdm-cart-toast]');
    if (toast) {
      toast.classList.remove('is-visible');
    }
  }

  function getButton(form) {
    return form.querySelector('[data-cdm-ajax-cart-button], [data-add-to-cart], [data-search-add-to-cart], button[type="submit"], input[type="submit"]');
  }

  function getTextNode(button) {
    return button && (
      button.querySelector('[data-cdm-ajax-cart-text]') ||
      button.querySelector('.cdm-btn-text') ||
      button.querySelector('.button-text') ||
      button.querySelector('[data-add-to-cart-text]')
    );
  }

  function setButtonLabel(button, label) {
    if (!button) return;

    var textNode = getTextNode(button);

    if (textNode) {
      if (!textNode.dataset.cdmOriginalText) {
        textNode.dataset.cdmOriginalText = textNode.textContent.trim();
      }
      textNode.textContent = label;
      textNode.hidden = false;
      textNode.style.display = 'inline-block';
      return;
    }

    if (!button.dataset.cdmOriginalText) {
      button.dataset.cdmOriginalText = button.value || button.textContent.trim();
    }

    if (button.tagName === 'INPUT') {
      button.value = label;
    } else {
      button.textContent = label;
    }
  }

  function restoreButtonLabel(button) {
    if (!button) return;

    var textNode = getTextNode(button);
    if (textNode && textNode.dataset.cdmOriginalText) {
      textNode.textContent = textNode.dataset.cdmOriginalText;
      textNode.hidden = false;
      textNode.style.display = 'inline-block';
      return;
    }

    if (button.dataset.cdmOriginalText) {
      if (button.tagName === 'INPUT') {
        button.value = button.dataset.cdmOriginalText;
      } else {
        button.textContent = button.dataset.cdmOriginalText;
      }
    }
  }

  function setButtonState(button, state) {
    if (!button) return;

    var loading = button.querySelector('.button-loading');
    if (!loading) {
      loading = button.querySelector('.cdm-btn-loading');
    }

    var success = button.querySelector('.button-success');
    if (!success) {
      success = button.querySelector('.cdm-btn-success');
    }

    button.classList.toggle('button-loading', state === 'loading');
    button.classList.toggle('button-success', state === 'success');
    button.classList.toggle('cdm-ajax-cart-button--loading', state === 'loading');
    button.classList.toggle('cdm-ajax-cart-button--success', state === 'success');

    if (loading) {
      loading.hidden = state !== 'loading';
      loading.style.display = state === 'loading' ? 'inline-block' : 'none';
    }

    if (success) {
      success.hidden = true;
      success.style.display = 'none';
    }

    if (state === 'loading') {
      setButtonLabel(button, 'Adicionando...');
    } else if (state === 'success') {
      setButtonLabel(button, 'Adicionado');
    } else {
      restoreButtonLabel(button);
    }
  }

  function getFriendlyError(error) {
    var rawMessage = '';

    if (typeof error === 'string') {
      rawMessage = error;
    } else if (error && typeof error === 'object') {
      rawMessage = error.description || error.message || error.status || '';
    }

    rawMessage = String(rawMessage || '').trim();

    if (!rawMessage) {
      return 'Não foi possível adicionar o produto ao carrinho. Tente novamente.';
    }

    if (/sold out|out of stock|estoque|indispon|available|quantity|quantidade|maximum|can't add|cannot add|can only add|limite/i.test(rawMessage)) {
      return 'Quantidade indisponível no momento.';
    }

    if (/op[cç][aã]o|option|required|missing|selecione|escolha|par[aâ]metro/i.test(rawMessage)) {
      return 'Selecione as opções do produto antes de adicionar ao carrinho.';
    }

    return 'Não foi possível adicionar o produto ao carrinho. Tente novamente.';
  }

  function updateCartIndicators(cart) {
    if (!cart) return;

    document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
    });

    document.querySelectorAll('.cart-link__bubble').forEach(function(bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cdm:cart:updated', { detail: { cart: cart } }));
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options);
    var data = await response.json().catch(function() { return {}; });

    if (!response.ok) {
      throw data;
    }

    return data;
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }
  }

  async function submitAjax(form, options) {
    options = options || {};

    if (!form || form.dataset.cdmAjaxCart === 'false') {
      return;
    }

    if (form.dataset.cdmAjaxCartBusy === 'true') {
      return;
    }

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) {
      showToast('Selecione as opções do produto antes de adicionar ao carrinho.', true);
      return;
    }

    var button = options.button || getButton(form);
    form.dataset.cdmAjaxCartBusy = 'true';

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setButtonState(button, 'loading');
    }

    try {
      await fetchJson(route('cartAdd', '/cart/add.js'), {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (options.redirectToCheckout) {
        window.location.assign('/checkout');
        return;
      }

      var cart = await fetchJson(route('cart', '/cart.js'), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      updateCartIndicators(cart);
      setButtonState(button, 'success');
      showToast('Produto adicionado ao carrinho.');

      window.setTimeout(function() {
        if (button) {
          setButtonState(button, 'idle');
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        form.dataset.cdmAjaxCartBusy = 'false';
      }, 2200);
    } catch (error) {
      if (button) {
        setButtonState(button, 'idle');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }

      form.dataset.cdmAjaxCartBusy = 'false';
      showToast(getFriendlyError(error), true);
    }
  }

  function handleSubmit(event) {
    var form = event.target && event.target.closest(formSelector);

    if (!form || form.dataset.cdmAjaxCart === 'false') {
      return;
    }

    var submitter = event.submitter;
    if (submitter && submitter.dataset && submitter.dataset.cdmAjaxCartIgnore === 'true') {
      return;
    }

    stopEvent(event);
    submitAjax(form, {
      button: submitter || null,
      redirectToCheckout: !!(submitter && submitter.dataset && submitter.dataset.cdmBuyNow === 'true')
    });
  }

  function handleClick(event) {
    var clicked = event.target && event.target.closest('[data-cdm-ajax-cart-button], [data-add-to-cart], [data-search-add-to-cart], button[type="submit"], input[type="submit"]');
    var form = clicked && clicked.closest(formSelector);

    if (!form || form.dataset.cdmAjaxCart === 'false') {
      return;
    }

    if (clicked.dataset && clicked.dataset.cdmAjaxCartIgnore === 'true') {
      return;
    }

    stopEvent(event);
    submitAjax(form, {
      button: clicked,
      redirectToCheckout: !!(clicked.dataset && clicked.dataset.cdmBuyNow === 'true')
    });
  }

  function injectStyles() {
    if (document.getElementById('cdm-ajax-cart-styles')) return;

    var style = document.createElement('style');
    style.id = 'cdm-ajax-cart-styles';
    style.textContent = [
      '.grid-product__cta-form-premium{width:100%;margin-top:auto;}',
      '.grid-product__cta-form-premium .grid-product__cta-premium{margin-top:0;cursor:pointer;}',
      '.cdm-ajax-cart-button--loading,.cdm-ajax-cart-button--success{pointer-events:none;}',
      '.cdm-cart-toast{position:fixed;right:20px;bottom:20px;z-index:2147483000;width:min(360px,calc(100vw - 32px));padding:16px;background:#111;color:#fff;border:1px solid rgba(255,255,255,.14);border-radius:8px;box-shadow:0 18px 48px rgba(0,0,0,.28);opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .2s ease,transform .2s ease;}',
      '.cdm-cart-toast.is-visible{opacity:1;transform:translateY(0);pointer-events:auto;}',
      '.cdm-cart-toast--error{background:#2b1111;}',
      '.cdm-cart-toast__message{font-size:15px;line-height:1.35;font-weight:700;margin:0 0 12px;}',
      '.cdm-cart-toast__actions{display:flex;gap:8px;align-items:center;}',
      '.cdm-cart-toast__button{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:9px 12px;border-radius:6px;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.04em;text-decoration:none;cursor:pointer;}',
      '.cdm-cart-toast__button--primary{background:#ffc72c;color:#000;border:1px solid #ffc72c;}',
      '.cdm-cart-toast__button--secondary{background:transparent;color:#fff;border:1px solid rgba(255,255,255,.35);}',
      '@media (max-width:768px){.cdm-cart-toast{left:12px;right:12px;bottom:14px;width:auto;}.cdm-cart-toast__actions{flex-direction:column;align-items:stretch;}.cdm-cart-toast__button{width:100%;}}'
    ].join('');

    document.head.appendChild(style);
  }

  window.CDMAjaxCartFeedback = {
    show: showToast,
    hide: hideToast,
    error: function(error) {
      showToast(getFriendlyError(error), true);
    }
  };

  injectStyles();
  document.addEventListener('product-form:message:success', function(event) {
    if (event.detail) {
      event.detail.message = 'Produto adicionado ao carrinho.';
    }
  }, true);
  document.addEventListener('product-form:message:error', function(event) {
    if (event.detail) {
      event.detail.message = getFriendlyError(event.detail.message || event.detail.error || event.detail.response);
    }
  }, true);
  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', handleSubmit, true);
})();
